export type Category = 'artworks' | 'users' | 'settings';

export const Routes = {
  login: '/login',
  terms: '/terms',
  privacy: '/privacy',
  dashboard: '/dashboard',
  company(category: Category, companyId?: number) {
    return `${this.dashboard}/company/${companyId || ':companyId'}/${category}`;
  },
};
